module.exports = __webpack_public_path__ + "img/step-2.02dec35b.png";